import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import UnbxdCards from "../UnbxdCards/UnbxdCards";
import stl from "./UnbxdPosts.module.css";
import loadable from "@loadable/component";
import useIsMobile from "@hooks/useIsMobile";
import { thumbUrl } from "@/utils/imagesHelpers";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import WithScrollToTop from "@/common/HOCs/WithScrollToTop/WithScrollToTop";
import { CDN_LINK } from "@globalConfig";
import UnbxdTitleArea from "@/components/SearchComponent/UnbxdComponents/UnbxdTitleArea/UnbxdTitleArea";
import MarketingBanner from "@/components/SearchComponent/NewComponents/MarketingBanner/MarketingBanner";
import UnbxdSEOChips from "@/components/SearchComponent/UnbxdComponents/UnbxdSEOChips/UnbxdSEOChips";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import { useState, useEffect, useRef } from "react";
import useSticky from "@hooks/useSticky";
import { useLocation, useMatch, useSearchParams } from "react-router-dom";
import { useAuthActions } from "@/_MiniApps/auth/AuthContext";
import { useTranslation } from "@i18n";
import SaveSearchBanner from "@/components/SearchComponent/UnbxdComponents/UnbxdSaveSearch/SaveSearchBanner";
import BlueSnackBar from "@/_MiniApps/CarCompare/Components/BlueSnackBar";
import StartCompareBar from "@/_MiniApps/CarCompare/Components/StartCompareBar";
import { Pagination } from "@syarahtech/ui";
import useFilterPage, { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
import { SearchUspsProvider } from "@/components/SearchComponent/UnbxdComponents/SearchUsps/SearchUspsContext";
import Container from "@/components/sharedComponents/container/Container";
var fallback = {
  fallback: null
};
var EmptySearchResult = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "EmptySearchResult-EmptySearchResult";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "EmptySearchResult-EmptySearchResult" */"../EmptySearchResult/EmptySearchResult");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../EmptySearchResult/EmptySearchResult");
    }
    return eval('require.resolve')("../EmptySearchResult/EmptySearchResult");
  }
}, fallback);
var UnbxdRecommendationCards = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-SearchComponent-UnbxdComponents-UnbxdRecommendation-UnbxRecommendationCards";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-SearchComponent-UnbxdComponents-UnbxdRecommendation-UnbxRecommendationCards" */"@/components/SearchComponent/UnbxdComponents/UnbxdRecommendation/UnbxRecommendationCards");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/components/SearchComponent/UnbxdComponents/UnbxdRecommendation/UnbxRecommendationCards");
    }
    return eval('require.resolve')("@/components/SearchComponent/UnbxdComponents/UnbxdRecommendation/UnbxRecommendationCards");
  }
}, fallback);
var UnbxdPosts = function UnbxdPosts() {
  var _useFilterPage = useFilterPage(),
    loading = _useFilterPage.isLoading,
    page = _useFilterPage.page,
    isAutosPage = _useFilterPage.isAutosPage,
    isYearsPage = _useFilterPage.isYearsPage,
    isDealPage = _useFilterPage.isDealPage,
    isSearchSaved = _useFilterPage.isSearchSaved,
    total_pages = _useFilterPage.total_pages,
    setPage = _useFilterPage.setPage;
  var _useSearchResultsData = useSearchResultsData(),
    filters = _useSearchResultsData.filters,
    usps = _useSearchResultsData.usps,
    marketingBanner = _useSearchResultsData.marketingBanner,
    selectedOptions = _useSearchResultsData.selectedOptions,
    posts = _useSearchResultsData.posts,
    metaData = _useSearchResultsData.metaData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var isFiltersPage = !(isAutosPage || isYearsPage);
  var stickyRef = useRef(null);
  var isSticky = useSticky(stickyRef); // Use the custom hook
  var _useAuthActions = useAuthActions(),
    remote_saveSearchHistory = _useAuthActions.remote_saveSearchHistory; // Access the function
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var searchTermParam = searchParams.get("text");
  var location = useLocation();
  var banner = marketingBanner === null || marketingBanner === void 0 ? void 0 : marketingBanner[isMobile ? "mobile" : "desktop"];
  var url = typeof window !== "undefined" ? window.location.href : "/";
  var _useCarCompareContext = useCarCompareContext(),
    hasCarsToCompare = _useCarCompareContext.hasCarsToCompare;
  var _useState = useState(null),
    prevSearchTerm = _useState[0],
    setPrevSearchTerm = _useState[1];
  var currentPage = page;
  var isYearsMakeRoute = useMatch("/years/:year/:make");
  var isYearsRoute = useMatch("/years");
  var isMakeModelYearRoute = useMatch("/autos/:make/:model/:year");
  var isLessWrapper = !!isYearsMakeRoute || !!isMakeModelYearRoute || !!isYearsRoute;
  useEffect(function () {
    if (searchTermParam && searchTermParam !== prevSearchTerm &&
    // Check if search term changed
    !loading && posts.length > 0) {
      // Save search to history
      remote_saveSearchHistory({
        text: searchTermParam,
        label_ar: searchTermParam,
        label_en: searchTermParam,
        searched_at: Math.floor(Date.now() / 1000),
        filters: null,
        result_count: posts.length
      });

      // Update the previous search term state
      setPrevSearchTerm(searchTermParam);
    }
  }, [prevSearchTerm, loading, posts.length]);
  return /*#__PURE__*/React.createElement("div", {
    className: stl.mainWrapper
  }, !isFiltersPage && /*#__PURE__*/React.createElement("div", {
    className: isLessWrapper ? stl.autosAndTagsWrapperLess : stl.autosAndTagsWrapper
  }, !isFiltersPage && /*#__PURE__*/React.createElement(UnbxdSEOChips, null)), /*#__PURE__*/React.createElement("div", {
    className: [stl.searchResultContainer, stl.mainPostsWrapper].join(" ")
  }, (isDealPage || !isMobile && (banner || loading)) && /*#__PURE__*/React.createElement(MarketingBanner, {
    src: thumbUrl(banner, "hero-v1", isMobile ? "0x154" : "0x960"),
    progressiveSmallImage: thumbUrl(banner, "hero-v1", isMobile ? "0x99" : "0x154"),
    width: isMobile ? 351 : 1200,
    height: isMobile ? 119 : 187,
    marketingBanner: marketingBanner,
    loading: loading && !banner
  }), /*#__PURE__*/React.createElement("div", {
    ref: stickyRef
  }, !isSearchSaved && /*#__PURE__*/React.createElement("div", {
    className: "xl:hidden my-4"
  }, /*#__PURE__*/React.createElement(SaveSearchBanner, null)), /*#__PURE__*/React.createElement(UnbxdTitleArea, {
    loading: loading
  })), loading && isDesktop && /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "mt-1",
    divHeight: isMobile ? 40 : 40,
    divWidth: 199
  })), !loading && posts.length === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(EmptySearchResult, {
    filters: filters
  }), /*#__PURE__*/React.createElement(UnbxdRecommendationCards, null))), /*#__PURE__*/React.createElement(SearchUspsProvider, null, /*#__PURE__*/React.createElement(UnbxdCards, {
    loading: loading,
    posts: posts,
    usps: usps,
    page: page,
    metaData: metaData
  })), isAutosPage && total_pages > 1 && !loading && /*#__PURE__*/React.createElement("div", {
    className: "py-8"
  }, /*#__PURE__*/React.createElement(Pagination, {
    baseUrl: url,
    currentPage: currentPage,
    totalPages: total_pages,
    as: "link",
    onPageChange: function onPageChange(page) {
      setPage(page);
    }
  })), !isAutosPage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WithScrollToTop, {
    renderFunction: function renderFunction(_ref) {
      var onClick = _ref.onClick,
        isMouseOver = _ref.isMouseOver;
      return /*#__PURE__*/React.createElement("div", {
        onClick: onClick,
        className: isMouseOver ? "isMouseOver" : ""
      }, /*#__PURE__*/React.createElement("img", {
        width: "40px",
        src: CDN_LINK + "/assets/images/Backtotop.svg",
        alt: "Back To Top"
      }));
    }
  }))), /*#__PURE__*/React.createElement(BlueSnackBar, {
    postsLength: posts.length,
    loading: loading
  }), /*#__PURE__*/React.createElement(StartCompareBar, null));
};
export default UnbxdPosts;